import type { FC } from 'react';
import { UnitSkillBadge } from './UnitSkillBadge';
import { useAppSelector } from '../../redux/hooks';
import { selectedUnit } from '../../redux/reducers/unitSlice';
import { selectExitSlipDoneCountForTarget } from '../../redux/reducers/exitSlipDoneCountSlice';

interface Props {
  foundationsAllCompleted: boolean;
  supportCompleted: number;
  targetCompleted: number;
}

// The unit header's progress badges (Foundations / Support / Target / Exit Slip), shared by both header
// layouts — inline on the title's row while the unit is in progress, centered below it once complete.
//
// The first three counts come from the header, which derives them from the unit's own skills. The
// exit-slip count is unit-scoped too, but it cannot be derived from those skills — it comes from a
// separate query — so it is read from the store here, keyed by the unit on screen, rather than
// threaded through a header that has nothing to contribute to it.
export const UnitSkillBadgeRow: FC<Props> = ({ foundationsAllCompleted, supportCompleted, targetCompleted }) => {
  // The unit's id is a TargetNode id, the same one the exit tickets' lessons are filed under.
  const unit = useAppSelector(selectedUnit);
  const exitSlipsDone = useAppSelector(selectExitSlipDoneCountForTarget(unit?.id));

  return (
    <div className="tw-flex tw-items-center tw-gap-5">
      <UnitSkillBadge variant="foundations" isActive={foundationsAllCompleted} />
      <UnitSkillBadge variant="support" count={supportCompleted} />
      <UnitSkillBadge variant="target" count={targetCompleted} />
      <UnitSkillBadge variant="exit-slip" count={exitSlipsDone} />
    </div>
  );
};
